// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {

        "id": 1,
        "title": "Big Mac",
        "price": 2,
        "image": require('./assets/img/product/big-mac.jpg')
    },
    {
        "id": 2,
        "title": "Flip Flops",
        "price": 3,
        "image": require('./assets/img/product/flip-flops.jpg')
    },
    {
        "id": 3,
        "title": "Coca-Cola Pack",
        "price": 5,
        "image": require('./assets/img/product/coca-cola-pack.jpg')
    },
    {
        "id": 4,
        "title": "Movie Ticket",
        "price": 12,
        "image": require('./assets/img/product/movie-ticket.jpg')
    },
    {
        "id": 5,
        "title": "Book",
        "price": 15,
        "image": require('./assets/img/product/book.jpg')
    },
    {
        "id": 6,
        "title": "Lobster Dinner",
        "price": 45,
        "image": require('./assets/img/product/lobster-dinner.jpg')
    },
    {
        "id": 7,
        "title": "Video Game",
        "price": 60,
        "image": require('./assets/img/product/video-game.jpg')
    },
    {
        "id": 8,
        "title": "Amazon Echo",
        "price": 99,
        "image": require('./assets/img/product/amazon-echo.jpg')
    },
    {
        "id": 9,
        "title": "Year of Netflix",
        "price": 100,
        "image": require('./assets/img/product/year-of-netflix.jpg')
    },
    {
        "id": 10,
        "title": "Air Jordans",
        "price": 125,
        "image": require('./assets/img/product/air-jordans.jpg')
    },
    {
        "id": 11,
        "title": "Airpods",
        "price": 199,
        "image": require('./assets/img/product/airpods.jpg')
    },
    {
        "id": 12,
        "title": "Gaming Console",
        "price": 299,
        "image": require('./assets/img/product/gaming-console.jpg')
    },
    {
        "id": 13,
        "title": "Drone",
        "price": 350,
        "image": require('./assets/img/product/drone.jpg')
    },
    {
        "id": 14,
        "title": "Smartphone",
        "price": 699,
        "image": require('./assets/img/product/smartphone.jpg')
    },
    {
        "id": 15,
        "title": "Bike",
        "price": 800,
        "image": require('./assets/img/product/bike.jpg')
    },
    {
        "id": 16,
        "title": "Kitten",
        "price": 1500,
        "image": require('./assets/img/product/kitten.jpg')
    },
    {
        "id": 17,
        "title": "Puppy",
        "price": 1500,
        "image": require('./assets/img/product/puppy.jpg')
    },
    {
        "id": 18,
        "title": "Auto Rickshaw",
        "price": 2300,
        "image": require('./assets/img/product/auto-rickshaw.jpg')
    },
    {
        "id": 19,
        "title": "Horse",
        "price": 2500,
        "image": require('./assets/img/product/horse.jpg')
    },
    {
        "id": 20,
        "title": "Acre of Farmland",
        "price": 3000,
        "image": require('./assets/img/product/acre-of-farmland.jpg')
    },
    {
        "id": 21,
        "title": "Designer Handbag",
        "price": 5500,
        "image": require('./assets/img/product/designer-handbag.jpg')
    },
    {
        "id": 22,
        "title": "Hot Tub",
        "price": 6000,
        "image": require('./assets/img/product/hot-tub.jpg')
    },
    {
        "id": 23,
        "title": "Luxury Wine",
        "price": 7000,
        "image": require('./assets/img/product/luxury-wine.jpg')
    },
    {
        "id": 24,
        "title": "Diamond Ring",
        "price": 10000,
        "image": require('./assets/img/product/diamond-ring.jpg')
    },
    {
        "id": 25,
        "title": "Jet Ski",
        "price": 12000,
        "image": require('./assets/img/product/jet-ski.jpg')
    },
    {
        "id": 26,
        "title": "Rolex",
        "price": 15000,
        "image": require('./assets/img/product/rolex.jpg')
    },
    {
        "id": 27,
        "title": "Ford F-150",
        "price": 30000,
        "image": require('./assets/img/product/ford-f-150.jpg')
    },
    {
        "id": 28,
        "title": "Tesla",
        "price": 75000,
        "image": require('./assets/img/product/tesla.jpg')
    },
    {
        "id": 29,
        "title": "Monster Truck",
        "price": 150000,
        "image": require('./assets/img/product/monster-truck.jpg')
    },
    {
        "id": 30,
        "title": "Ferrari",
        "price": 250000,
        "image": require('./assets/img/product/ferrari.jpg')
    },
    {
        "id": 31,
        "title": "Single Family Home",
        "price": 300000,
        "image": require('./assets/img/product/single-family-home.jpg')
    },
    {
        "id": 32,
        "title": "Gold Bar",
        "price": 700000,
        "image": require('./assets/img/product/gold-bar.jpg')
    },
    {
        "id": 33,
        "title": "McDonalds Franchise",
        "price": 1500000,
        "image": require('./assets/img/product/mcdonalds-franchise.jpg')
    },
    {
        "id": 34,
        "title": "Superbowl Ad",
        "price": 5250000,
        "image": require('./assets/img/product/superbowl-ad.jpg')
    },
    {
        "id": 35,
        "title": "Yacht",
        "price": 7500000,
        "image": require('./assets/img/product/yacht.jpg')
    },
    {
        "id": 36,
        "title": "M1 Abrams",
        "price": 8000000,
        "image": require('./assets/img/product/m1-abrams.jpg')
    },
    {
        "id": 37,
        "title": "Formula 1 Car",
        "price": 15000000,
        "image": require('./assets/img/product/formula-1-car.jpg')
    },
    {
        "id": 38,
        "title": "Apache Helicopter",
        "price": 31000000,
        "image": require('./assets/img/product/apache-helicopter.jpg')
    },
    {
        "id": 39,
        "title": "Mansion",
        "price": 45000000,
        "image": require('./assets/img/product/mansion.jpg')
    },
    {
        "id": 40,
        "title": "Make a Movie",
        "price": 100000000,
        "image": require('./assets/img/product/make-a-movie.jpg')
    },
    {
        "id": 41,
        "title": "Boeing 747",
        "price": 148000000,
        "image": require('./assets/img/product/boeing-747.jpg')
    },
    {
        "id": 42,
        "title": "Mona Lisa",
        "price": 780000000,
        "image": require('./assets/img/product/mona-lisa.jpg')
    },
    {
        "id": 43,
        "title": "Skyscraper",
        "price": 850000000,
        "image": require('./assets/img/product/skyscraper.jpg')
    },
    {
        "id": 44,
        "title": "Cruise Ship",
        "price": 930000000,
        "image": require('./assets/img/product/cruise-ship.jpg')
    },
    {
        "id": 45,
        "title": "NBA Team",
        "price": 2120000000,
        "image": require('./assets/img/product/nba-team.jpg')
    }
]
